var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInventory2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_2729",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_2729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 18.3334C3.70833 18.3334 3.31597 18.1702 2.98958 17.8438C2.66319 17.5174 2.5 17.1251 2.5 16.6667V7.27092C2.25 7.11814 2.04861 6.92022 1.89583 6.67717C1.74305 6.43411 1.66667 6.15286 1.66667 5.83342V3.33341C1.66667 2.87508 1.82986 2.48272 2.15625 2.15633C2.48264 1.82994 2.875 1.66675 3.33333 1.66675H16.6667C17.125 1.66675 17.5174 1.82994 17.8438 2.15633C18.1701 2.48272 18.3333 2.87508 18.3333 3.33341V5.83342C18.3333 6.15286 18.2569 6.43411 18.1042 6.67717C17.9514 6.92022 17.75 7.11814 17.5 7.27092V16.6667C17.5 17.1251 17.3368 17.5174 17.0104 17.8438C16.684 18.1702 16.2917 18.3334 15.8333 18.3334H4.16667ZM3.33333 5.83342H16.6667V3.33341H3.33333V5.83342ZM8.33333 11.6667H11.6667C11.9028 11.6667 12.1007 11.5869 12.2604 11.4272C12.4201 11.2674 12.5 11.0695 12.5 10.8334C12.5 10.5973 12.4201 10.3994 12.2604 10.2397C12.1007 10.0799 11.9028 10.0001 11.6667 10.0001H8.33333C8.09722 10.0001 7.89931 10.0799 7.73958 10.2397C7.57986 10.3994 7.5 10.5973 7.5 10.8334C7.5 11.0695 7.57986 11.2674 7.73958 11.4272C7.89931 11.5869 8.09722 11.6667 8.33333 11.6667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInventory2);
export default __webpack_public_path__ + "static/media/icon_inventory_2.55f876e2be9d68552d3b5f53920f0b7b.svg";
export { ForwardRef as ReactComponent };